import { AREA_COLOR_CATEGORIES } from './color-by';

// Well filters for the Area detail page — the same three attributes the colour-by
// modal offers, so one facet call serves both. Each maps to a wells-query array param.

/** Attribute id → the wells-query param carrying its selected bucket ids. */
export const WELL_FILTER_PARAM: Record<string, string> = {
  status: 'status_ids',
  currentOperator: 'current_operator_ids',
  holeDirection: 'hole_direction_ids',
};

export interface WellFilterCategory {
  id: string;
  label: string;
}

// The same three attributes the colour-by modal offers, in the same order — declared
// once there so adding a fourth can't leave the two lists disagreeing.
export const WELL_FILTER_CATEGORIES: WellFilterCategory[] =
  AREA_COLOR_CATEGORIES;

/** Selected bucket ids per attribute. An attribute with none is left out. */
export type WellFilters = Record<string, string[]>;

// The label for an attribute id, for the applied-filter chips.
export const wellFilterLabel = (id: string): string =>
  WELL_FILTER_CATEGORIES.find((category) => category.id === id)?.label ?? id;

// The filters as wells-query params. Snake-cased to match the rest of that body, and
// empty selections are dropped so an unused attribute never narrows the query.
export const wellFilterQueryParams = (
  filters: WellFilters
): Record<string, string[]> => {
  const params: Record<string, string[]> = {};
  Object.entries(filters).forEach(([attribute, values]) => {
    const param = WELL_FILTER_PARAM[attribute];
    if (param && values.length > 0) {
      params[param] = values;
    }
  });
  return params;
};

// How many attributes are actually filtering, for the rail's count.
export const activeFilterCount = (filters: WellFilters): number =>
  Object.values(filters).filter((values) => values.length > 0).length;
